import { Button, Flex, Space } from 'antd'
import React from 'react'
import { AssignmentPermissions, Forbiddances } from '../../../../constants/assignment-permissions'
import Access from '../access/Access'

export const EditPatternModalFooter = ({
    pattern,
    onDeletePattern,
    isWaitingForPatternSave,
    projectionCostDetails,
    criteriaChanged,
    isAssignmentTooBigForProjection,
}) => {
    return (
        <Flex justify='end'>
            <Space>
                <Access permissions={[AssignmentPermissions.CAN_EDIT]}>
                    <Button danger onClick={onDeletePattern} disabled={!pattern}>
                        Delete
                    </Button>
                </Access>
                <Access
                    permissions={[AssignmentPermissions.CAN_EDIT]}
                    skipForbiddances={[
                        Forbiddances.IS_VERSION_PUBLISHED,
                        Forbiddances.IS_VERSION_NOT_LATEST,
                        Forbiddances.VERSION_HAS_MBAS,
                        Forbiddances.IS_PROCESSING,
                    ]}
                >
                    <Button
                        type='primary'
                        htmlType='submit'
                        form='edit-pattern'
                        loading={isWaitingForPatternSave}
                        disabled={!pattern || isAssignmentTooBigForProjection}
                    >
                        Save {criteriaChanged && `${projectionCostDetails}`}
                    </Button>
                </Access>
            </Space>
        </Flex>
    )
}
